<template>
  <div class="space-y-6">
    <div class="flex items-center justify-between">
      <h1 class="text-2xl font-bold text-neutral-900 dark:text-neutral-100 tracking-tight">Sites</h1>
    </div>

    <div class="bg-white dark:bg-neutral-800 rounded-xl shadow-soft border border-neutral-200 dark:border-neutral-700">
      <EmptyState
        icon="domain"
        title="Site management coming soon"
        message="Sites are currently managed directly by an administrator. This page isn't available yet."
      />
    </div>
  </div>
</template>

<script>
import EmptyState from "@/components/ui/EmptyState.vue";

export default {
  name: "SitesView",
  components: { EmptyState },
};
</script>
